import useI18n from "@/hooks/useI18n";

interface WebViewHeaderProps {
  onOpenMenu: () => void;
  onGoBack: () => void;
}

export function WebViewHeader({ onOpenMenu, onGoBack }: WebViewHeaderProps) {
  const { t } = useI18n();
  return (
    <div className="w-full bg-white shadow-[0px_2px_4px_0px_rgba(0,0,0,0.04)]">
      <div className="w-full h-[60px] flex items-center justify-center px-4 relative">
        <button
          onClick={onGoBack}
          type="button"
          className="absolute left-4 w-6 h-6 flex items-center justify-center z-10"
          aria-label="Voltar para o app"
        >
          <img
            src="/svg/icon-arrow-left.svg"
            alt="Voltar"
            className="w-6 h-6"
          />
        </button>

        <h1 className="text-[#0e0d0d] text-base whitespace-nowrap ">
          {t("common:siteName")}
        </h1>

        <button
          onClick={onOpenMenu}
          type="button"
          className="absolute right-4 w-10 h-10 flex items-center justify-center text-[#363636] text-3xl font-light z-10"
          aria-label="Abrir menu"
        >
          +
        </button>
      </div>
    </div>
  );
}

export default WebViewHeader;
